import { format, parse } from "date-fns";
import { FormattedMessage as FM } from "react-intl";

import {
  PlaneDepartureIcon,
  PlaneArrivalIcon,
  UsersIcon,
  CoinIcon,
} from "components/Icons";
import { cn } from "tools/ui";

const FORMAT = "dd.MMM";

const base =
  "bg-white m-1 pt-2 px-4 shadow-md inline-block h-38 w-full md:w-56 cursor-pointer rounded-2xl border border-white shadow-neutral-300 overflow-hidden active:scale-95 active:shadow-xl";
const divHead = "flex text-neutral-800 justify-between";
const divContent = "h-fit py-1 text-neutral-600 text-sm";
const clickableStyle = "cursor-pointer active:scale-95 active:shadow-xl";

function CardFolio({ record, layout, onClick }) {
  const { model, args, card_action = [] } = layout;
  // console.log("Card folio layout args...", layout);

  const key = record.id;

  const selectable = card_action.includes("open");
  let clickable = selectable ? clickableStyle : "";

  let actionDelete = false;
  if (card_action) {
    for (const action of card_action) {
      if (action === "delete") {
        actionDelete = true;
      }
    }
  }

  function handleClick() {
    onClick(record);
  }

  const state = `${model}.${record.registration_state}`;
  const styleState = layout.tags.registration_state[record.registration_state];
  const arrival_date = format(
    parse(record.arrival_date, "yyyy-MM-dd", new Date()),
    FORMAT,
  );
  const departure_date = format(
    parse(record.departure_date, "yyyy-MM-dd", new Date()),
    FORMAT,
  );

  // const { payments, rec_name: bkNumber } = record["booking."];
  let hasPayments;
  let holder;
  // let guest;
  let numberDoc;
  const booking = record["booking."];
  hasPayments = booking?.payments?.length > 0;
  holder = booking?.contact;
  const guest = record.main_guest?.name ?? <FM id="hotel.folio.no_guest" />;
  if (args?.showFolioNumber) {
    numberDoc = record.number;
  } else {
    numberDoc = booking?.number;
  }
  if (booking?.party.name) {
    holder = booking?.party.name;
  }

  return (
    <div key={key} className={cn(base, clickable)} onClick={handleClick}>
      <div className={divHead}>
        <div className="font-bold text-md">{record.room.rec_name}</div>
        <span className="text-xs text-neutral-400">{numberDoc}</span>
      </div>
      <div className={divContent}>
        <div className="flex truncate font-bold text-xs text-neutral-400 mb-4 justify-between">
          <span>{record.product.name}</span>
          {hasPayments && (
            <CoinIcon className="h-4 text-teal-500 my-auto fill-current" />
          )}
          <div className={cn("w-4 h-4 rounded-full", styleState)}></div>
        </div>
        <div className="flex my-2 text-xs text-neutral-600">
          <PlaneArrivalIcon className="h-5 text-yellow-700 fill-current" />
          <span className="ml-3 mr-auto">{arrival_date}</span>
          <span className="mx-auto">|</span>
          <span className="ml-auto mr-3">{departure_date}</span>
          <PlaneDepartureIcon className="h-5 text-yellow-700 fill-current" />
        </div>
        <div className="flex mt-3 justify-between">
          <div className="flex my-auto">
            <UsersIcon className="h-4 text-sky-600/50 my-auto fill-current" />
            <span className="ml-1 text-neutral-700 text-sm">{record.pax}</span>
          </div>
          <span className="text-sm my-auto text-neutral-500">
            {record.nights_quantity} noc
          </span>
        </div>
        <div className="flex">
          <span className="mt-1 font-medium truncate text-neutral-500">
            {guest}
          </span>
        </div>
      </div>
    </div>
  );
}

export default CardFolio;
